import { Flex, useMantineTheme } from '@mantine/core';
import { MRT_Cell, MRT_Row } from 'mantine-react-table';
import { GetAiModelSearchHistoryResponseItem } from '@manifest-cyber/types/dist/contracts/model-analysis/search/history/get.contract';

export const RiskScoreColumn = ({
  cell,
  row,
}: {
  cell: MRT_Cell<GetAiModelSearchHistoryResponseItem>;
  row: MRT_Row<GetAiModelSearchHistoryResponseItem>;
}) => {
  const riskScoreMap = {
    high: 'High',
    medium: 'Med',
    low: 'Low',
    none: 'N/A',
    pending: 'Pending',
    '': 'N/A',
  };
  const theme = useMantineTheme();
  const riskScore = row.original.riskScore;

  // Use same logic as ModelRiskCell for handling null/undefined values
  if (!riskScore) {
    return null;
  }

  return (
    <span>
      <Flex
        sx={{
          borderRadius: '4px',
          color: riskScore === 'medium' ? theme.black : theme.white,
          width: 'fit-content',
          minWidth: '3rem',
          padding: '4px',
          justifyContent: 'center',
          backgroundColor:
            riskScore === 'high'
              ? theme.colors.red[5]
              : riskScore === 'medium'
                ? theme.colors.yellow[5]
                : riskScore === 'low'
                  ? theme.colors.dark[6]
                  : theme.colors.gray[5],
        }}
      >
        {riskScoreMap[riskScore || '']}
      </Flex>
    </span>
  );
};
